import * as React from 'react';

import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';

export function Identify() {
    return (
        <OnboardingBody title='Identifying your site visitors…'>
            <p>Although not magic, Nutshell Analytics is pretty cool.</p>
            <p>
                Once a site visitor submits a form on your website, we are able to gather this
                information about them.
            </p>
        </OnboardingBody>
    );
}
